const SCHEDULLER_CONFIG_PERMISSIONS = Object.freeze([
   "shift_manager",
   "plant_manager",
   "dock_manager",
   "plant_quota_manager",
   "client_quota_manager"
]);

const NEW_SCHEDULING = 'novo agendamento';

const getSchedulingPermissionsFromGroup = groups => {
   return SCHEDULLER_CONFIG_PERMISSIONS.filter(
      (g) => groups.includes(g)
   );
}

function canSeeSchedulingMenu(groups) {

   const backofficeWithPermission = groups.includes('backoffice') &&
      (
         getSchedulingPermissionsFromGroup(groups).length > 0
      );

   return groups.includes('support') || backofficeWithPermission;
}

export const getSchedulerConfigMenus = (groups) => {
   return (
      groups.includes("support") ? SCHEDULLER_CONFIG_PERMISSIONS : (
         groups.includes("backoffice") ?
            getSchedulingPermissionsFromGroup(groups) :
            []
      )
   ).map(group => ({ ...schedulerConfig[group] }))
      .filter((group) => !!group && !!Object.keys(group).length);
};

export const getUserSettings = (userMainGroup, groups) => {
   if (!userMainGroup) return null;

   if (groups.includes('user') && groups.length === 1) return [];

   let menus =  [];
   if (userMainGroup === 'backoffice') {
      if (groups.includes('cargill_transports'))
         menus = settings['cargill_CT'];
      if (groups.includes('backoffice'))
         menus = [...menus, ...settings[userMainGroup]];
   } else {
      menus = settings[userMainGroup];
   }

   if (userMainGroup === 'support') {
      if (groups.includes('cargill_transports'))
         menus = [...menus, ...settings['cargill_CT']];
   }

   if (groups.includes("backoffice_invoice")) {
      menus = [...menus, ...settings.backoffice_invoice];
   }

   if (groups.includes("transporter_invoice")) {
      menus = [...menus, ...settings.transporter_invoice];
   }

   if ((groups.includes("support") ||
      groups.includes("backoffice") ||
      groups.includes("transporter")
      ) && groups.includes("user_admin")) {
      menus = [...menus, ...settings.user_admin];
   }

   if (canSeeSchedulingMenu(groups)) {
      const scheduleGroups = getSchedulerConfigMenus(groups);
      if (!!scheduleGroups.length) {
         menus = [...menus, ...Object.values(...scheduleGroups)];
      }
   }


   if (userMainGroup === "support" && groups.includes("backoffice")) {
     menus = [...menus, ...settings.backoffice];
    }

    if ((groups.includes("backoffice") && groups.includes("scheduler")) || groups.includes("support")) {
       menus = [...menus, ...scheduler];
    }

   if (userMainGroup === "transporter") {
      menus = [...menus, ...scheduler];
   }

   if (userMainGroup === "farmer") {
      menus = [...menus, ...scheduler];
   }

   if (userMainGroup === "driver") {
      menus = [...menus, ...scheduler.filter(menu => menu.title.toUpperCase() !== NEW_SCHEDULING.toUpperCase())];
   }

   if (userMainGroup === "check_in_agent" && groups.includes("check_in_agent")) {
      menus = scheduler.filter(menu => menu.title.toUpperCase() !== NEW_SCHEDULING.toUpperCase());
   }

   if (userMainGroup === "client" && groups.includes("client", "scheduler")) {
      menus = [...scheduler];
   }

   if (userMainGroup === "vendor" && groups.includes("vendor", "scheduler")) {
      menus = [...scheduler];
   }

   if (groups.includes("warehouse")) {
    menus = [...settings.warehouse];
   }

   if (groups.includes("certifier")) {
    menus = [...settings.certifier];
   }

   //console.log({ menus})
   return menus;
};

export const getCurrentMainRoute = (
   userMainGroup,
   groups,
   locationPathName
) => {
   if (userMainGroup) {
      const settings = getUserSettings(userMainGroup, groups);
      const segment = locationPathName.split("/")[1];
      const route = settings.length && settings.filter((r) => r.route === `/${segment}`);
      return route && route.length ? route[0] : {};
   }
   return {};
};

const scheduler = [
  {
    title: "Novo agendamento",
    route: "/peach/scheduling",
    subRoutes: [
       {
          id: 1,
          title: "Novo agendamento",
          route: "/peach/scheduling",
       }
    ]
  },
   {
      title: "Acompanhamento de agend. CASC",
      route: "/agendamento",
      subRoutes: [
         {
            id: 1,
            title: "Agendamento",
            route: "/agendamento",
         },
         {
            id: 1,
            title: "Novo agendamento",
            route: "/agendamento/novo",
         },
         {
            id: 1,
            title: 'Agendamentos todos',
            route: "/agendamento/todos",
         },
         {
            id: 1,
            title: 'Agendamentos agendados',
            route: "/agendamento/agendados",
         },
         {
            id: 1,
            title: 'Agendamentos em fila',
            route: "/agendamento/fila",
         },
         {
            id: 1,
            title: 'Agendamentos chamado',
            route: "/agendamento/chamado",
         },
         {
            id: 1,
            title: 'Agendamentos em atendimento',
            route: "/agendamento/atendimento",
         },
         {
            id: 1,
            title: 'Agendamentos cancelados',
            route: "/agendamento/cancelados",
         },
         {
            id: 1,
            title: 'Agendamentos concluídos',
            route: "/agendamento/concluidos",
         },
         {
            id: 1,
            title: "Status Agendamento",
            route: "/agendamento/status/:id",
         }
      ]
   },
];

const schedulerConfig = {
   shift_manager: [
      {
         title: "Configurações de agendamento",
         route: "/agendamento/configuracoes/turno",
         subRoutes: [
            {
               id: 1,
               title: "Configurações de agendamento",
               route: "/agendamento/configuracoes/turno",
            }
         ]
      },
   ],
   plant_manager: [
      {
         title: "Configurações de agendamento",
         route: "/agendamento/configuracoes/planta",
         subRoutes: [
            {
               id: 1,
               title: "Configurações de agendamento",
               route: "/agendamento/configuracoes/planta",
            }
         ]
      },
   ],
   dock_manager: [
      {
         title: "Configurações de agendamento",
         route: "/agendamento/configuracoes/docas",
         subRoutes: [
            {
               id: 1,
               title: "Configurações de agendamento",
               route: "/agendamento/configuracoes/docas",
            }
         ]
      },
   ],
   plant_quota_manager: [
      {
         title: "Configurações de agendamento",
         route: "/agendamento/configuracoes/cotaplanta",
         subRoutes: [
            {
               id: 1,
               title: "Configurações de agendamento",
               route: "/agendamento/configuracoes/cotaplanta",
            }
         ]
      },
   ],
   client_quota_manager: [
      {
         title: "Configurações de agendamento",
         route: "/agendamento/configuracoes/cotacliente",
         subRoutes: [
            {
               id: 1,
               title: "Configurações de agendamento",
               route: "/agendamento/configuracoes/cotacliente",
            }
         ]
      },
   ],
};
const settings = {
   support: [
      {
         title: "Suporte",
         route: "/suporte",
         subRoutes: [
            {
               id: 6,
               title: "Ordens de Carregamento",
               icon: "check-square",
               color: "#1080A6",
               description: "Loading_Orders/index",
               action: "Loading_Orders/index",
               route: "/suporte/ordens-carregamento",
               type: "view",
            },
            {
               id: 7,
               title: "Usuários",
               icon: "check-square",
               color: "#1080A6",
               description: "Users/index",
               action: "Users/index",
               route: "/suporte/usuarios",
               type: "view",
            },
            {
               id: 8,
               title: "Filiais Destino",
               icon: "check-square",
               color: "#1080A6",
               description: "/Branches/index",
               action: "/Branches/index",
               route: "/suporte/filiais-destino",
               type: "view",
            },
            {
               id: 9,
               title: "Filiais Origem",
               icon: "check-square",
               color: "#1080A6",
               description: "/Branches_Origin/index",
               action: "/Branches_Origin/index",
               route: "/suporte/filiais-origem",
               type: "view",
            },
            {
               id: 10,
               title: "Fazendas Expedidoras",
               icon: "check-square",
               color: "#1080A6",
               description: "/Farms/index",
               action: "/Farms/index",
               route: "/suporte/fazendas-expedidoras",
               type: "view",
            },
            {
               id: 11,
               title: "Fazendas Remetentes",
               icon: "check-square",
               color: "#1080A6",
               description: "/Farms_Origin/index",
               action: "/Farms_Origin/index",
               route: "/suporte/fazendas-origem",
               type: "view",
            },
            {
               id: 12,
               title: "Motoristas",
               icon: "check-square",
               color: "#1080A6",
               description: "/Drivers/index",
               action: "/Drivers/index",
               route: "/suporte/motoristas",
               type: "view",
            },
            {
               id: 13,
               title: "Transportadoras",
               icon: "check-square",
               color: "#1080A6",
               description: "/Transporters/index",
               action: "/Transporters/index",
               route: "/suporte/transportadoras",
               type: "view",
            },
            {
               id: 14,
               title: "Logs",
               icon: "check-square",
               color: "#1080A6",
               description: "/Logs/index",
               action: "/Logs/index",
               route: "/suporte/logs",
               type: "view",
            },
         ],
      },
   ],
   cargill_CT: [
      // {
      //    title: "Enviar Documentos",
      //    route: "/cargill-transports",
      //    subRoutes: [
      //       {
      //          id: 4,
      //          title: "Enviar Documentos de entrada",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Backoffice/sendDocumentsIn",
      //          action: "Backoffice/sendDocumentsIn",
      //          route: "/cargill-transports/enviar-documentos",
      //          type: "view",
      //       }
      //    ],
      // },
      {
         title: "Enviar Documentos",
         route: "/peach/new/tdms/cargill-transports/loading-orders",
         subRoutes: [
            {
               id: 1,
               title: "Enviar Documentos",
               route: "/peach/new/tdms/cargill-transports/loading-orders",
            }
         ],
      },
   ],
   backoffice: [
      // {
      //    title: "Trocar Documentos",
      //    route: "/trocar-documentos",
      //    subRoutes: [
      //       {
      //          id: 4,
      //          title: "Validar os Documentos",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Backoffice/validateDocumentsIn",
      //          action: "Backoffice/validateDocumentsIn",
      //          route: "/trocar-documentos/validar-documentos",
      //          type: "view",
      //       },
      //       {
      //          id: 5,
      //          title: "Adicionar Documentos",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Backoffice/loadingOrdersDocuments",
      //          action: "Backoffice/loadingOrdersDocuments",
      //          route: "/trocar-documentos/adicionar-documentos",
      //          type: "view",
      //       },
      //       {
      //          id: 24,
      //          title: "OCs com Documentos",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Backoffice/loadingOrdersWithDocuments",
      //          action: "Backoffice/loadingOrdersWithDocuments",
      //          route: "/trocar-documentos/ocs-com-documentos",
      //          type: "view",
      //       },
      //       {
      //          id: 25,
      //          title: "OCs Canceladas",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Backoffice/loadingOrdersCanceled",
      //          action: "Backoffice/loadingOrdersCanceled",
      //          route: "/trocar-documentos/ocs-canceladas",
      //          type: "view",
      //       },
      //    ],
      // },
      {
         title: "Trocar Documentos",
         route: "/peach/new/tdms/backoffice/loading-orders",
         subRoutes: [
            {
               id: 1,
               title: "Trocar Documentos",
               route: "/peach/new/tdms/backoffice/loading-orders",
            }
         ],
      },
      {
         title: "Backoffice Homepage",
         route: "/trocar-documentos/backoffice-homepage",
         subRoutes: [
            {
               id: 1,
               title: "Backoffice Homepage",
               route: "/trocar-documentos/backoffice-homepage",
            }
         ],
      },
   ],
   backoffice_invoice: [
      {
         title: "Factura Argentina Backoffice",
         route: "/peach/new/tdms/freight-invoice/backoffice",
         subRoutes: [
            {
               id: 1,
               title: "Factura Argentina Backoffice",
               route: "/peach/new/tdms/freight-invoice/backoffice",
            }
         ],
      },
   ],
   user_admin: [
      {
         title: "Gerenciar Usuários",
         route: "/gerenciar-usuarios",
         subRoutes: [
            {
               id: 6,
               title: "Gerenciar Usuários",
               icon: "check-square",
               color: "#1080A6",
               description: "Users/list",
               action: "Users/list",
               route: "/gerenciar-usuarios/listar-usuarios",
               type: "view",
            },
            {
               id: 7,
               title: "Editar Usuários",
               icon: "check-square",
               color: "#1080A6",
               route: "/gerenciar-usuarios/editar-usuario/:id",
               type: "view",
            },
            {
               id: 8,
               title: "Novo Usuário",
               icon: "check-square",
               color: "#1080A6",
               route: "/gerenciar-usuarios/novo-usuario",
               type: "view",
            },
            {
              id: 9,
              title: "Aprovar Usuário",
              icon: "check-square",
              color: "#1080A6",
              route: "/gerenciar-usuarios/aprovar-usuarios",
              type: "view",
            },
         ],
      },
   ],
   farmer: [
      // {
      //    title: "Trocar Documentos",
      //    route: "/trocar-documentos",
      //    subRoutes: [
      //       {
      //          id: 2,
      //          title: "Carregamentos",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Farmer/loadingOrders",
      //          action: "Farmer/loadingOrders",
      //          route: "/trocar-documentos/carregamentos-fazenda",
      //          type: "view",
      //       },
      //       {
      //          id: 3,
      //          title: "Acompanhar Status",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Farmer/timeline",
      //          action: "Farmer/timeline",
      //          route: "/trocar-documentos/acompanhar-status-fazenda",
      //          type: "view",
      //       },
      //    ],
      // },
      {
         title: "Trocar Documentos",
         route: "/peach/new/tdms/farm/loading-orders",
         subRoutes: [
            {
               id: 1,
               title: "Trocar Documentos",
               route: "/peach/new/tdms/farm/loading-orders",
            }
         ],
      },
   ],
    certifier: [
      {
      title: "Trocar Documentos",
      route: "/trocar-documentos",
      subRoutes: [
          {
            id: 2,
            title: "Carregamentos",
            icon: "check-square",
            color: "#1080A6",
            description: "Warehouse/loadingOrders",
            action: "Warehouse/loadingOrders",
            route: "/trocar-documentos/carregamentos-warehouse",
            type: "view",
          },
          {
            id: 3,
            title: "Acompanhar Status",
            icon: "check-square",
            color: "#1080A6",
            description: "Warehouse/timeline",
            action: "Warehouse/timeline",
            route: "/trocar-documentos/acompanhar-status-warehouse",
            type: "view",
          },
      ],
    },
    ],
   warehouse: [
  //   {
  //     title: "Trocar Documentos",
  //     route: "/trocar-documentos",
  //     subRoutes: [
  //        {
  //           id: 2,
  //           title: "Carregamentos",
  //           icon: "check-square",
  //           color: "#1080A6",
  //           description: "Warehouse/loadingOrders",
  //           action: "Warehouse/loadingOrders",
  //           route: "/trocar-documentos/carregamentos-warehouse",
  //           type: "view",
  //        },
  //        {
  //           id: 3,
  //           title: "Acompanhar Status",
  //           icon: "check-square",
  //           color: "#1080A6",
  //           description: "Warehouse/timeline",
  //           action: "Warehouse/timeline",
  //           route: "/trocar-documentos/acompanhar-status-warehouse",
  //           type: "view",
  //        },
  //     ],
  //  },
   {
        title: "Trocar Documentos",
        route: "/peach/new/tdms/warehouse/loading-orders",
        subRoutes: [
          {
              id: 1,
              title: "Trocar Documentos",
              route: "/peach/new/tdms/warehouse/loading-orders",
          }
        ],
    },
 ],
   farm: [
  //   {
  //     title: "Trocar Documentos",
  //     route: "/trocar-documentos",
  //     subRoutes: [
  //        {
  //           id: 2,
  //           title: "Carregamentos",
  //           icon: "check-square",
  //           color: "#1080A6",
  //           description: "Warehouse/loadingOrders",
  //           action: "Warehouse/loadingOrders",
  //           route: "/trocar-documentos/carregamentos-warehouse",
  //           type: "view",
  //        },
  //        {
  //           id: 3,
  //           title: "Acompanhar Status",
  //           icon: "check-square",
  //           color: "#1080A6",
  //           description: "Warehouse/timeline",
  //           action: "Warehouse/timeline",
  //           route: "/trocar-documentos/acompanhar-status-warehouse",
  //           type: "view",
  //        },
  //     ],
  //  },
   {
        title: "Trocar Documentos",
        route: "/peach/new/tdms/farm/loading-orders",
        subRoutes: [
          {
              id: 1,
              title: "Trocar Documentos",
              route: "/peach/new/tdms/farm/loading-orders",
          }
        ],
    },
 ],
   driver: [
      {
         title: "Trocar Documentos",
         route: "/trocar-documentos",
         subRoutes: [
            {
               id: 2,
               title: "Carregamentos",
               icon: "check-square",
               color: "#1080A6",
               description: "Driver/loadingOrders",
               action: "Driver/loadingOrders",
               route: "/trocar-documentos/carregamentos-motorista",
               type: "view",
            },
            {
               id: 3,
               title: "Acompanhar Status",
               icon: "check-square",
               color: "#1080A6",
               description: "Driver/timeline",
               action: "Driver/timeline",
               route: "/trocar-documentos/acompanhar-status-motorista",
               type: "view",
            },
            {
               id: 4,
               title: "Pesquisar Carregamento",
               icon: "check-square",
               color: "#1080A6",
               description: "Driver/index",
               action: "Driver/index",
               route: "/trocar-documentos/pesquisar-carregamentos",
               type: "view",
               notShowInTab: true,
            },
         ],
      },
   ],
   transporter: [
      // {
      //    title: "Trocar Documentos",
      //    route: "/trocar-documentos",
      //    subRoutes: [
      //       {
      //          id: 4,
      //          title: "Validar os Documentos",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Transporter/validateDocumentsIn",
      //          action: "Transporter/validateDocumentsIn",
      //          route: "/trocar-documentos/validar-documentos-transportadoras",
      //          type: "view",
      //       },
      //       {
      //          id: 6,
      //          title: "Adicionar Documentos",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Transporter/listLoadingOrders",
      //          action: "Transporter/listLoadingOrders",
      //          route: "/trocar-documentos/carregamentos-transportadoras",
      //          type: "view",
      //       },
      //       {
      //          id: 25,
      //          title: "OCs Canceladas",
      //          icon: "check-square",
      //          color: "#1080A6",
      //          description: "Transporter/loadingOrdersCanceled",
      //          action: "Transporter/loadingOrdersCanceled",
      //          route: "/trocar-documentos/ocs-canceladas",
      //          type: "view",
      //       },
      //    ],
      // },
      {
         title: "Trocar Documentos",
         route: "/peach/new/tdms/transporter/loading-orders",
         subRoutes: [
            {
               id: 1,
               title: "Trocar Documentos",
               route: "/peach/new/tdms/transporter/loading-orders",
            }
         ],
      },
   ],
   transporter_invoice: [
      {
         title: "Factura Argentina Transportista",
         route: "/peach/new/tdms/freight-invoice/transportista",
         subRoutes: [
            {
               id: 1,
               title: "Factura Argentina Transportista",
               route: "/peach/new/tdms/freight-invoice/transportista",
            }
         ],
      },
   ],
};
